/**
 * Outbound referrals (NEW-WF-12): `/referrals` (`?patient=`), with the
 * specialist directory.
 */
import { defineManifest } from '@velora/contracts';
import { REFERRALS_PERMISSIONS as P } from '@velora/contracts/referrals';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'referrals',
    title: 'Referrals',
    version: '0.1.0',
    owner: 'WP4-REFERRALS',
    entitlementKey: null,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'list',
        path: '/referrals',
        title: 'Referrals',
        officeScope: 'location',
        permission: P.view,
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Referrals',
        group: 'clinical',
        routeId: 'list',
        icon: 'send',
        order: 70,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'referrals.list',
        title: 'Referrals out',
        keywords: ['refer', 'specialist', 'oral surgeon', 'endo', 'perio', 'referral letter'],
        routeId: 'list',
        permission: P.view,
      },
    ],
    sseEntityKeys: ['referral_out'],
    phiReadPoints: ['referrals.list'],
  }),
  pages: {
    list: () => import('./ReferralsPage.js'),
  },
});
